<template>
    <PopupRouterView :showLeftIcon="true" :label="modalTitle"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="receiptfromproduction"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="receiptFromProductionInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-work-order-process-detail" ref="fieldset-work-order-process-detail" :model.sync="workOrderProcessDetailQrCode" label="Work Order Lot Number" @scannedMethod="scanWorkOrderProcessDetail" :isBusy="isScanLoading" autofocus />
						<app-list :isDataLoading="isWorkOrderProcessDetailIsLoading" :dataCount="workOrderProcessDetails.length">
								<work-order-process-detail-item v-for="(item,index) in workOrderProcessDetails" :model="item" :key="index" @nextAction="scanWorkOrderProcessDetail(item.lotNo)"/>
							</app-list>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2 || scanPageIndex == 3 || scanPageIndex == 4">
				<app-label label-cols-lg="12" size="sm" label="Lot No" :model="workOrderProcessDetail.lotNo" />
				<b-row>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Part Number" :model="workOrderProcessDetail.part.partNumber"></app-label>
						<app-label label-cols-lg="12" size="sm" label="Qty Produksi" :model="prodResult.okQty"></app-label>
					</b-col>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="workOrderProcessDetail.part.partName"></app-label>
						<app-label v-if="scanPageIndex == 3 || scanPageIndex == 4" label-cols-lg="12" size="sm" label="Qty Plan" :model="workOrderProcessDetail.qtyPlan"></app-label>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Qty Ng" :model="prodResult.ngQty"></app-label>
					</b-col>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Qty Pending" :model="prodResult.pendingQty"></app-label>
					</b-col>
					<b-col cols="12">
						<app-input-scan id="fieldset-receipt-material" ref="fieldset-receipt-material" :model.sync="materialQrCode" label="Scan Control Card (MCC)" @scannedMethod="scanControlCardMaterial" :isBusy="isScanLoading" autofocus />

						<p class="table-title">Scanned Control Card (Material)</p>
						<b-table id="table-list-suggestion" class="table-action" head-variant="head-light"
						:bordered="true" :items="receiptFromProductionMaterials" :fields="fieldsReceiptFromProductionMaterial" small responsive show-empty>
						<template #empty>
							<!-- <app-no-data-image /> -->
						</template>

						<template #cell(no)="row">
							{{ row.index + 1 }}
						</template>

						<template #cell(qty)="row">
							{{ row.qtyBefore }}
						</template>
						
						</b-table>

					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-receipt-from-production-case" ref="fieldset-receipt-from-production-case" :model.sync="receiptFromProductionCaseQrCode" label="Scan Control Card (PCC)" @scannedMethod="scanReceiptFromProductionCase" :isBusy="isScanLoading" :waitInputScan="waitInputCaseProd" @clearMethod="clearMethodCaseProd"  autofocus />
						<!-- <app-input-textbox id="input-qty-product" label-cols-lg="12" label="Qty" size="sm" :model.sync="qtyProduct" :isUpdatable="false" :isEditable="true" @change="inputQty" :disabled="!caseScanned" /> -->
					</b-col>
					<b-col cols="12">
						<p class="table-title">Scanned Control Card (PCC)</p>
						<b-table id="table-case" class="table-action" head-variant="head-light" :bordered="true"
						:items="receiptFromProductionCases" :fields="fieldsReceiptFromProductionCase" small responsive show-empty>
							
							<template #empty>
								<!-- <app-no-data-image /> -->
							</template>

							<template #cell(no)="row">
								{{ row.index + 1 }}
							</template>

							<template #cell(deliveryDate)="row">
								{{ formatDate(row.item.controlCard.deliveryDate) }}
							</template>

						</b-table>

						<p class="table-title">Scanned Control Card (Material)</p>
						<b-table id="table-list-suggestion" :class="'table-action'" head-variant="head-light"
						:bordered="true" :items="receiptFromProductionMaterials" :fields="fieldsUsedControlCardMaterial" small responsive show-empty>
						<template #empty>
							<!-- <app-no-data-image /> -->
						</template>

						<template #cell(no)="row">
							{{ row.index + 1 }}
						</template>
						
						</b-table>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 4">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-receipt-material-ok" ref="fieldset-receipt-material-ok" :model.sync="materialQrCode" label="Scan Control Card (MCC)" @scannedMethod="scanControlCardMaterial" :isBusy="isScanLoading" autofocus />

						<p class="table-title">Scanned Control Card (Material)</p>
						<b-table id="table-list-suggestion" :class="'table-action'" head-variant="head-light"
						:bordered="true" :items="receiptFromProductionMaterials" :fields="fieldsReceiptFromProductionMaterial" small responsive show-empty>
						<template #empty>
							<!-- <app-no-data-image /> -->
						</template>

						<template #cell(no)="row">
							{{ row.index + 1 }}
						</template>

						<template #cell(qty)="row">
							{{ row.qtyAfter }}
						</template>
						
						</b-table>
					</b-col>
				</b-row>
			</span>
        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-danger float-right" @click="resetRFP">Back</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" @click="createNgPendingCase">Next</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right" @click="finishRFP">Finish</b-button>
			<b-button v-if="scanPageIndex == 4" size="sm" class="btn-fill-success float-right" @click="inputQty">Save</b-button>
			<!-- <b-button size="sm" variant="primary" @click="switchPage(-1)">prev</b-button>
			<b-button size="sm" variant="primary" @click="switchPage(1)">next</b-button> -->
        </template>

    </PopupRouterView>
</template>
<style scoped>
	.table-title {
		margin-top: 20px !important;
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import AppLabel from '@/components/AppLabel';
import ReceiptFromProduction from '@/models/ReceiptFromProduction/ReceiptFromProduction';
import ReceiptFromProductionFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionFilter';
import WorkOrderProcessDetailItem from './components/WorkOrderProcessDetailItem';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import ReceiptFromProductionMaterial from '@/models/ReceiptFromProduction/ReceiptFromProductionMaterial';
import ReceiptFromProductionMaterialFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionMaterialFilter';
import ReceiptFromProductionCase from '@/models/ReceiptFromProduction/ReceiptFromProductionCase';
import ReceiptFromProductionCaseFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionCaseFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import BillOfMaterial from '@/models/BillOfMaterial/BillOfMaterial';
import BillOfMaterialFilter from '@/filters/BillOfMaterial/BillOfMaterialFilter';
import BillOfMaterialDetail from '@/models/BillOfMaterial/BillOfMaterialDetail';
import BillOfMaterialDetailFilter from '@/filters/BillOfMaterial/BillOfMaterialDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppLabel,
		PopupRouterView,
		AppInputScan,
		AppList,
		WorkOrderProcessDetailItem,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsReceiptFromProductionMaterial: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Source Material", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"qtyTaken": { "class" : "th-qty-after d-stack-none", "label" : "Qty Terpakai", key: 'qtyTaken', sortable: false}}, 
				{"qtyAfter": { "class" : "th-qty-after d-stack-none", "label" : "Qty Tersedia", key: 'qtyAfter', sortable: false}},
			],
			fieldsUsedControlCardMaterial: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Source Material", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"qtyTaken": { "class" : "th-qty-after d-stack-none", "label" : "Qty Terpakai", key: 'qtyTaken', sortable: false}}, 
				{"qtyAfter": { "class" : "th-qty-after d-stack-none", "label" : "Qty Tersedia", key: 'qtyAfter', sortable: false}},
			],
			fieldsReceiptFromProductionCase: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part.partNumber', sortable: false}}, 
				{"deliveryDate": {"class": "th-deliveryDate", "label": "Delivery Date", key: "deliveryDate", sortable:false}},
				{"qtyMaterial": { "class" : "th-qty-material last-child", "label" : "Qty Material", key: 'qtyMaterial', sortable: false}}, 
				{"qtyCase": { "class" : "th-qty-case d-stack-none", "label" : "Qty Case", key: 'qtyCase', sortable: false}}, 
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelReceiptFromProductionMaterial : {},
			isShowPopupReceiptFromProductionMaterial : false,
			isShowPopupUploadReceiptFromProductionMaterial : false,
			isShowPopupReceiptFromProductionMaterialScan : false,
			modelReceiptFromProductionCase : {},
			isShowPopupReceiptFromProductionCase : false,
			isShowPopupUploadReceiptFromProductionCase : false,
			isShowPopupReceiptFromProductionCaseScan : false,
			filterReceiptFromProduction : null,
			currentReceiptFromProductionPage : 1,
			receiptFromProductionPageSize: 10,
			sortByReceiptFromProduction: '',
			sortDescReceiptFromProduction: '',
			filterReceiptFromProductionMaterial : null,
			currentReceiptFromProductionMaterialPage : 1,
			receiptFromProductionMaterialPageSize: 10,
			sortByReceiptFromProductionMaterial: '',
			sortDescReceiptFromProductionMaterial: '',
			sortingByReceiptFromProductionMaterial: [],
			receiptFromProductionMaterials : [],
			receiptFromProductionMaterialId : '',
			totalReceiptFromProductionMaterialRow : 0,
			isShowReceiptFromProductionMaterialFilter: false,
			isDownloadReceiptFromProductionMaterial: false,
			filterReceiptFromProductionCase : null,
			currentReceiptFromProductionCasePage : 1,
			receiptFromProductionCasePageSize: 10,
			sortByReceiptFromProductionCase: '',
			sortDescReceiptFromProductionCase: '',
			sortingByReceiptFromProductionCase: [],
			receiptFromProductionCases : [],
			receiptFromProductionCaseId : '',
			totalReceiptFromProductionCaseRow : 0,
			isShowReceiptFromProductionCaseFilter: false,
			isDownloadReceiptFromProductionCase: false,
			controlCards: [],
			parts: [],
			workOrderProcessDetails: [],
			isWorkOrderProcessDetailComboLoading: false,
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isReceiptFromProductionComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			workOrderProcessDetailQrCode: '',
			ProdQrCode: '',
			receiptFromProductionCaseQrCode: '',
			isScanWorkOrderProcessDetailLoading: false,
			isScanReceiptFromProductionCaseLoading: false,
			isScanReceiptFromProductionMaterialLoading: false,
			isWorkOrderProcessDetailWorkOrderProcessDetailsLoading: false,
			workOrderProcessDetailWorkOrderProcessDetails: [],
			controlCardCase: {},
			billOfMaterial: {},
			billOfMaterialDetails : [],
			controlCardMaterialNumber: '',
			qtyProduct: 0,
			usedControlCardMaterials : [],
			workOrderProcessDetail : {},
			prodResult: {},
			materialQrCode: '',
			modalTitle: 'Receipt From Production Input',
			caseScanned: false,
			waitInputCaseProd: false,
			isWorkOrderProcessDetailIsLoading: false,
			isScanLoading: false,
		}
	},
	methods : {
		formatDate(stringDate) {
			if(!stringDate || stringDate == null || stringDate == undefined) return;

			const date = new Date(stringDate);
			const day = String(date.getDate()).padStart(2, '0');
			const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
			const year = date.getFullYear();
			return `${day}-${month}-${year}`;
		},
		clearMethodCaseProd() {
			this.waitInputCaseProd = false;
			this.receiptFromProductionCaseQrCode = '';
		},
		switchPage(target) {
			this.scanPageIndex = this.scanPageIndex + target < 1 ? 1 : this.scanPageIndex + target > 5 ? 5 : this.scanPageIndex + target;
			return;
		},
		updateUsedQty() {
			this.usedControlCardMaterials.forEach(item => {
				item.usedQty = item.bomUsedQty * this.qtyProduct;
			});
		},
		getRowClass(item, row) {
			if(!item || row !== "row") return;
			if(item.isScanned == true) return "table-success"
		},
		getReceiptFromProduction : async function(id) {
			this.isBusy = true;
			await ReceiptFromProduction.getData(this, id).then(async result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				// if(this.model.workOrderProcessDetailId) {
				// 	 await this.getDeliveryDate();
				// }

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		getWorkOrderProcessDetail : async function(id) {
			this.isBusy = true;
			await WorkOrderProcessDetail.getData(this, id).then(result => {
				this.workOrderProcessDetail = result;
				//this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadReceiptFromProduction = true;
			this.filterReceiptFromProduction.id = this.modelId;
			ReceiptFromProduction.downloadDataDetail(this, this.filterReceiptFromProduction).then(result => {
				this.isDownloadReceiptFromProduction = false;
			}).catch(error => { this.isDownloadReceiptFromProduction = false; })
		},
		async getReceiptFromProductionMaterials(isAddRow, draftMode) {
			if (this.modelId == null) return;

			const filter = {
				...this.filterReceiptFromProductionMaterial,
				receiptFromProductionId: this.modelId,
			};

			if (this.sortByReceiptFromProductionMaterial != null) {
				this.sortingByReceiptFromProductionMaterial[this.sortByReceiptFromProductionMaterial] = this.sortDescReceiptFromProductionMaterial;
			}

			let currentPage = isAddRow ? Math.ceil((this.totalReceiptFromProductionMaterialRow + 1) / this.receiptFromProductionMaterialPageSize) - 1 : this.currentReceiptFromProductionMaterialPage - 1;

			// Disable paging
			currentPage = null;
			this.receiptFromProductionMaterialPageSize = 0;

			try {
				const result = await ReceiptFromProductionMaterial.getList(this, filter, this.sortingByReceiptFromProductionMaterial, currentPage, this.receiptFromProductionMaterialPageSize);

				this.currentReceiptFromProductionMaterialPage = currentPage + 1;
				this.receiptFromProductionMaterials = result.data;
				this.totalReceiptFromProductionMaterialRow = result.dataCount;
			} catch (error) {
				// Handle the error
			}
		},
		async getReceiptFromProductionCases(isAddRow) {
			if (this.modelId == null) return;

			const filter = {
				...this.filterReceiptFromProductionCase,
				receiptFromProductionId: this.modelId,
			};

			if (this.sortByReceiptFromProductionCase != null) {
				this.sortingByReceiptFromProductionCase[this.sortByReceiptFromProductionCase] = this.sortDescReceiptFromProductionCase;
			}

			let currentPage = isAddRow ? Math.ceil((this.totalReceiptFromProductionCaseRow + 1) / this.receiptFromProductionCasePageSize) - 1 : this.currentReceiptFromProductionCasePage - 1;

			// Disable paging
			currentPage = null;
			this.receiptFromProductionCasePageSize = 0;

			try {
				const result = await ReceiptFromProductionCase.getList(this, filter, this.sortingByReceiptFromProductionCase, currentPage, this.receiptFromProductionCasePageSize);

				this.currentReceiptFromProductionCasePage = currentPage + 1;
				this.receiptFromProductionCases = result.data;

				this.totalReceiptFromProductionCaseRow = result.dataCount;
			} catch (error) {
				// Handle the error
			}
		},
		getReceiptFromProductions : async function(input) {
			let filter = new ReceiptFromProductionFilter();
			if (input != undefined) {
				filter.WorkOrderProcessDetail = input;
			}
			filter.documentStatusId = "IN_PROGRESS,CLOSED";

			this.isReceiptFromProductionComboLoading = true;
			await ReceiptFromProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.receiptFromProductions = result.data
				}
				this.isReceiptFromProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				//filter.controlCardNumber = input;
				filter.id = input
			}
			this.isControlCardComboLoading = true;
			await ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getBillOfMaterial : async function(input) {
			let filter = new BillOfMaterialFilter();
			if (input != undefined) {
				//filter.controlCardNumber = input;
				filter.partNumberId = input
			}
			//this.isBillOfMaterialComboLoading = true;
			await BillOfMaterial.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfMaterial = result.data[0];
				}
				//this.isBillOfMaterialComboLoading = false;
			})
			.catch(error => {});

			await this.getBillOfMaterialDetails(this.billOfMaterial.id);
		},
		getBillOfMaterialDetails : async function(input) {
			let filter = new BillOfMaterialDetailFilter();
			if (input != undefined) {
				//filter.controlCardNumber = input;
				filter.billOfMaterialId = input
			}
			//this.isBillOfMaterialComboLoading = true;
			await BillOfMaterialDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfMaterialDetails = result.data;
					//this.getBillOfMaterialDetails(this.billOfMaterial.id);
				}
				//this.isBillOfMaterialComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}

			filter.documentStatusId = 'IN_PROGRESS';
			await WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}

			filter.id = "IN_PROGRESS,CLOSED";

			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.receiptFromProductionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					ReceiptFromProduction.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'receiptfromproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					ReceiptFromProduction.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'receiptfromproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return ReceiptFromProduction.updateData(this, model, id)
					.catch((error) => {
						return this.getReceiptFromProduction(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getReceiptFromProductions();
		},
		addRowDataReceiptFromProductionMaterial(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.receiptFromProductionId =  this.modelId;
					ReceiptFromProductionMaterial.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getReceiptFromProductionMaterials(true);
						this.isShowPopupReceiptFromProductionMaterial = false;
					})
				} else {
					model.receiptFromProductionId =  this.modelId;
					ReceiptFromProductionMaterial.createDataDetail(this, model)
					.then(result => {
						this.getReceiptFromProductionMaterials(true);
						this.isShowPopupReceiptFromProductionMaterial = false;
					})
				}
			}
		},
		async editRowDataReceiptFromProductionMaterial(id) {
			this.receiptFromProductionMaterialId = id;
			this.isShowPopupReceiptFromProductionMaterial = true; 
		},
		async deleteRowDataReceiptFromProductionMaterial(id) {
			ReceiptFromProductionMaterial.deleteData(this, id).then(result => { this.getReceiptFromProductionMaterials(); });
		},
		async resetDataReceiptFromProductionMaterial() {
			this.receiptFromProductionMaterialId = "";
			this.isShowPopupReceiptFromProductionMaterial = true;
		},
		async addDataReceiptFromProductionMaterial() {
			ReceiptFromProductionMaterial.createData(this, { receiptFromProductionId: this.modelId })
			.then(result => {
				this.getReceiptFromProductionMaterials(true);
			})
		},
		async addFromClipboardReceiptFromProductionMaterial() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, receiptFromProductionId: this.modelId });
				});
				ReceiptFromProductionMaterial.addFromClipboard(this, controlCards).then(result => { this.getReceiptFromProductionMaterials() });
			});
		},
		async replaceFromClipboardReceiptFromProductionMaterial() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, receiptFromProductionId: this.modelId });
				});
				ReceiptFromProductionMaterial.replaceFromClipboard(this, controlCards).then(result => { this.getReceiptFromProductionMaterials() });
			});   
		},
		showPopupUploadReceiptFromProductionMaterial() {
			this.isShowPopupUploadReceiptFromProductionMaterial = true;
		},
		uploadDataReceiptFromProductionMaterial(modalEvent, newDatas) {
			this.isShowPopupUploadReceiptFromProductionMaterial = false; 
		},
		downloadReceiptFromProductionMaterial(modalEvent) {
			this.isDownloadReceiptFromProductionMaterial = true;
			this.filterReceiptFromProductionMaterial.receiptFromProductionId = this.modelId;
			ReceiptFromProductionMaterial.downloadDataDetail(this, this.filterReceiptFromProductionMaterial).then(result => {
				this.isDownloadReceiptFromProductionMaterial = false;
			}).catch(error => { this.isDownloadReceiptFromProductionMaterial = false; })
		},
		saveInputReceiptFromProductionMaterial(item) {
			if (this.receiptFromProductions != null && this.receiptFromProductions != undefined  && this.receiptFromProductions.length > 0) {
				item.receiptFromProduction = this.receiptFromProductions.find(q => q.id == item.receiptFromProductionId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ReceiptFromProductionMaterial.updateData(this, item, item.id);
				}
			});
		},
		addRowDataReceiptFromProductionCase(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.receiptFromProductionId =  this.modelId;
					ReceiptFromProductionCase.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getReceiptFromProductionCases(true);
						this.isShowPopupReceiptFromProductionCase = false;
					})
				} else {
					model.receiptFromProductionId =  this.modelId;
					ReceiptFromProductionCase.createDataDetail(this, model)
					.then(result => {
						this.getReceiptFromProductionCases(true);
						this.isShowPopupReceiptFromProductionCase = false;
					})
				}
			}
		},
		async editRowDataReceiptFromProductionCase(id) {
			this.receiptFromProductionCaseId = id;
			this.isShowPopupReceiptFromProductionCase = true; 
		},
		async deleteRowDataReceiptFromProductionCase(id) {
			ReceiptFromProductionCase.deleteData(this, id).then(result => { this.getReceiptFromProductionCases(); });
		},
		async resetDataReceiptFromProductionCase() {
			this.receiptFromProductionCaseId = "";
			this.isShowPopupReceiptFromProductionCase = true;
		},
		async addDataReceiptFromProductionCase() {
			ReceiptFromProductionCase.createData(this, { receiptFromProductionId: this.modelId })
			.then(result => {
				this.getReceiptFromProductionCases(true);
			})
		},
		async addFromClipboardReceiptFromProductionCase() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, receiptFromProductionId: this.modelId });
				});
				ReceiptFromProductionCase.addFromClipboard(this, controlCards).then(result => { this.getReceiptFromProductionCases() });
			});
		},
		async replaceFromClipboardReceiptFromProductionCase() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, receiptFromProductionId: this.modelId });
				});
				ReceiptFromProductionCase.replaceFromClipboard(this, controlCards).then(result => { this.getReceiptFromProductionCases() });
			});   
		},
		showPopupUploadReceiptFromProductionCase() {
			this.isShowPopupUploadReceiptFromProductionCase = true;
		},
		uploadDataReceiptFromProductionCase(modalEvent, newDatas) {
			this.isShowPopupUploadReceiptFromProductionCase = false; 
		},
		downloadReceiptFromProductionCase(modalEvent) {
			this.isDownloadReceiptFromProductionCase = true;
			this.filterReceiptFromProductionCase.receiptFromProductionId = this.modelId;
			ReceiptFromProductionCase.downloadDataDetail(this, this.filterReceiptFromProductionCase).then(result => {
				this.isDownloadReceiptFromProductionCase = false;
			}).catch(error => { this.isDownloadReceiptFromProductionCase = false; })
		},
		saveInputReceiptFromProductionCase(item) {

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ReceiptFromProductionCase.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadReceiptFromProductionMaterial = false; 
			this.isShowPopupReceiptFromProductionMaterial = false; 
			if (modalType == 'ReceiptFromProductionMaterial') {
				this.getReceiptFromProductionMaterials();
			}
			this.isShowPopupUploadReceiptFromProductionCase = false; 
			this.isShowPopupReceiptFromProductionCase = false; 
			if (modalType == 'ReceiptFromProductionCase') {
				this.getReceiptFromProductionCases();
			}
			this.workOrderProcessDetailQrCode = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		// async getDeliveryDate() {
		// 	const response = await this.$http.get(`ReceiptFromProduction/getdeliverydate/${this.model.workOrderProcessDetailId}`);
		// 	if(response && response.data) {
		// 		this.deliveryDate = response.data;
		// 	}
		// },
		async createNgPendingCase() {
			try {
				const id = this.model.id;
				await this.$http.post(`ReceiptFromProductionMaterial/NgPendingCase/${id}`);

				await this.getReceiptFromProductionCases();
				await this.getReceiptFromProductionMaterials();

				this.goToNext(3);
			} catch (error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-receipt-material");
				});
			}
		},
		async scanControlCardMaterial() {
			try {
				if(this.isScanLoading) return;
				this.isScanLoading = true;
				const qrCode = encodeURIComponent(this.materialQrCode);
				const id = this.model.id;

				const responseCheck = await this.$http.get(`ReceiptFromProductionMaterial/CheckSourceMaterial/${id}/?qrcode=${qrCode}`);

				if(responseCheck && responseCheck.data) {
					let message = `Terdapat Control Card ${qrCode} yang lebih lama secara produksi, apakah akan tetap melanjutkan dengan control card ini?`;
					if(!await this.showPopupWithMessage(message))  {
						this.materialQrCode = '';
						this.isScanLoading = false;
						return;
					}

					await this.scanRfpMaterialAction(id, qrCode);
					this.isScanLoading = false;
				} else if(responseCheck) {
					await this.scanRfpMaterialAction(id, qrCode);
					this.isScanLoading = false;
				}
				

				await this.getReceiptFromProductionMaterials();
				this.materialQrCode = '';
				this.isScanLoading = false;
			} catch(error) {
				this.isScanLoading = false;
				this.materialQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				let fieldSet = this.scanPageIndex == 2 ? 'receipt-material' : 'receipt-material-ok';
				this.$nextTick(() => {
					this.focusInput(this, `fieldset-${fieldSet}`);
				});
			} finally {
				this.isScanLoading = false;
			}
		},
		async scanWorkOrderProcessDetail(qr) {
			try {
				if(this.isScanLoading) return;
				this.isScanLoading = true;
				if(qr) {
					this.workOrderProcessDetailQrCode = qr;
				}
				const qrCode = encodeURIComponent(this.workOrderProcessDetailQrCode);
				const id = this.model.id;

				const response = await this.$http.get(`ReceiptFromProduction/ScanWorkOrderProcessDetail?id=${id}&qrcode=${qrCode}`);

				if (!response || !response.data) {
					this.toast({ message: 'Work Order not found!', title: 'Error', variant: 'danger' });
					this.isScanLoading = false;
					return;
				}

				const item = response.data;
				this.prodResult = item.prodResult;

				if(item.result != 0) {
					this.modelId = item.result;
				}

				await this.getReceiptFromProductionCases();
				let caseExist = this.receiptFromProductionCases.length > 0;

				await this.getReceiptFromProductionMaterials();

				const hasNgOrPending = item.prodResult.ngQty > 0 || item.prodResult.pendingQty > 0;

				if (item.result == 0) {
					await this.getReceiptFromProduction(id);
					await this.getWorkOrderProcessDetail(this.model.workOrderProcessDetailId);
					
					if(caseExist) {
						this.isScanLoading = false;
						this.goToNext(3, this.model.id);
					} else {
						this.isScanLoading = false;
						this.goToNext(hasNgOrPending ? 2 : 3, this.model.id);
					}

					return;
				}

				await this.getReceiptFromProduction(item.result);
				await this.getWorkOrderProcessDetail(this.model.workOrderProcessDetailId);

				const nextRoute = '/receiptfromproduction/scan/' + item.result;
				if (this.$route.path === nextRoute) {
					this.isScanLoading = false;
					if(caseExist) {
						this.goToNext(3, item.result);
					} else {
						this.goToNext(hasNgOrPending ? 2 : 3, item.result);
					}
				} else {
					this.isScanLoading = false;
					this.$router.replace(nextRoute, () => {
						if(caseExist) {
							this.goToNext(3, item.result);
						} else {
							this.goToNext(hasNgOrPending ? 2 : 3, item.result);
						}
					});
				}
			} catch (error) {
				this.isScanLoading = false;
				this.workOrderProcessDetailQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-work-order-process-detail");
				});
			}
			finally {
				this.isScanLoading = false;
			}
		},
		async scanReceiptFromProductionMaterial() {
			try {
				if(this.isScanLoading) return;
				this.isScanLoading = true;
				const qrCode = encodeURIComponent(this.materialQrCode);
				const id = this.model.id;

				const responseCheck = await this.$http.get(`ReceiptFromProductionMaterial/CheckSourceMaterial/${id}/?qrcode=${qrCode}`);
				if(responseCheck && responseCheck.data) {
					this.isScanLoading = false;
					let message = `Terdapat Control Card ${qrCode} yang lebih lama secara produksi, apakah akan tetap melanjutkan dengan control card ini?`;
					if(!await this.showPopupWithMessage(message))  {
						this.materialQrCode = '';
						return;
					}
					
					const response = await this.$http.get(`ReceiptFromProductionMaterial/ScanControlCard?id=${id}&qrcode=${qrCode}`);
					if (response && response.data) {
						this.ProdQrCode = '';
						await this.getReceiptFromProductionMaterials();
						this.isScanLoading = false;
					} else {
						this.isScanLoading = false;
						this.toast({ message: 'Source Material is not listed in Table!', title: 'Error', variant: 'danger' });
					}

				} else if(responseCheck) {
					const response = await this.$http.get(`ReceiptFromProductionMaterial/ScanControlCard?id=${id}&qrcode=${qrCode}`);
					if (response && response.data) {
						this.ProdQrCode = '';
						await this.getReceiptFromProductionMaterials();
						this.isScanLoading = false;
					} else {
						this.isScanLoading = false;
						this.toast({ message: 'Source Material is not listed in Table!', title: 'Error', variant: 'danger' });
					}
				}
			} catch (error) {
				this.isScanLoading = false;
				this.ProdQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-receipt-material");
				});
			} finally {
				this.isScanLoading = false;
			}
		},
		async scanRfpMaterialAction(id, qrCode) {
			try {
				if(this.qtyProduct <= 0) {
					await this.$http.get(`receiptfromproductionmaterial/ScanMaterialCardNgPending/${id}?qrcode=${qrCode}`);
				} else {
					await this.$http.get(`receiptfromproductionmaterial/ScanMaterialCardOk/${id}?qrcode=${qrCode}&qty=${this.qtyProduct}`);
				}
			} catch(error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			} finally {
				this.materialQrCode = '';
			}
		},
		async scanReceiptFromProductionCase() {
			try {
				if(this.isScanLoading) return;
				this.isScanLoading = true;
				const qrCode = encodeURIComponent(this.receiptFromProductionCaseQrCode);
				const id = this.model.id;

				const response = await this.$http.get(`ReceiptFromProductionCase/ScanControlCard?id=${id}&wopdId=${this.model.workOrderProcessDetailId}&qrcode=${qrCode}`);

				if (response && response.data) {
					//TODO: change this to appropriate method
					//this.goToNext(2, response.data.data[0]);
					await this.getControlCards(response.data);
					this.controlCardCase = this.controlCards[0];
					this.qtyProduct = this.controlCardCase.part.standarPackagingQty;
					this.caseScanned = true;
					this.waitInputCaseProd = true;

					await this.getReceiptFromProductionMaterials();
					if(this.receiptFromProductionMaterials.length == 0) {
						this.qtyProduct == 0;
						this.isScanLoading = false;
						this.goToNext(4);
						return;
					} else {
						await this.inputQty();
						this.isScanLoading = false;
					}

				} else {
					this.isScanLoading = false;
					this.toast({ message: 'Cannot find Control Card!', title: 'Error', variant: 'danger' });
				}
			} catch (error) {
				this.isScanLoading = false;
				this.receiptFromProductionCaseQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-receipt-from-production-case");
				});
			} finally {
				this.isScanLoading = false;
			}
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		async finishRFP() {
			try {
				if(!await this.showPopupWithMessage("Apakah anda yakin ingin menyelesaikan Proses RFP?")) return;
				const id = this.model.id;
				const response = await this.$http.post(`ReceiptFromProduction/finishrfp/${id}`);

				if (response && response.data) {
					//TODO: change this to appropriate method
					this.$router.back();
				}
			} catch (error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			}
		},
		async resetRFP() {
			try {
				if(!await this.showPopupWithMessage("Data akan di reset apakah anda yakin?")) return;
				const id = this.model.id;
				await this.$http.post(`ReceiptFromProduction/resetrfp/${id}`);
				await this.getReceiptFromProduction(id);
				await this.getReceiptFromProductionMaterials();
				this.workOrderProcessDetailQrCode = '';
				let pageTarget = this.scanPageIndex == 2 ? 1 : 3;
				this.goToNext(pageTarget, null);

			} catch (error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			}
		},
		async saveRFPtoSavedState() {
			try {
				const id = this.model.id;
				const response = await this.$http.post(`ReceiptFromProduction/saverfptosavedstate/${id}`);

				if (response && response.data) {
					//TODO: change this to appropriate method
					this.goToNext(3, null);
				}
			} catch (error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			}
		},
		async inputQty() {
			try {
				const id = this.model.id;
				const controlCardId = this.controlCardCase.id;
				const qtyProduct = this.qtyProduct;

				if(qtyProduct == 0) {
					this.caseScanned = false;
					this.clearMethodCaseProd()
					this.goToNext(3); 
					return;
				}

				const response = await this.$http.post(`ReceiptFromProduction/inputqty/${id}?controlCardId=${controlCardId}&qty=${qtyProduct}`);
				if (response && response.data.code >= 0) {
					await this.getReceiptFromProductionMaterials();
					await this.getReceiptFromProductionCases();
					if(response.data.code == 1) {
						if(this.receiptFromProductionMaterials.length > 0) {
							let error = response.data.message;
							this.toast({message: error, title: 'System Error', variant: 'danger', autoHideDelay: 3000})
						}
						this.goToNext(4, null)
					} else {
						this.receiptFromProductionCaseQrCode = '';
						this.usedControlCardMaterials = [];
						this.controlCardMaterialNumber = '';
						this.qtyProduct = 0;
						this.caseScanned = false;
						this.clearMethodCaseProd();
						this.goToNext(3, null);
					}
				}
			} catch (error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				let fieldSet = this.scanPageIndex == 3 ? 'receipt-from-production-case' : 'receipt-material-ok';
				this.$nextTick(() => {
					this.focusInput(this, `fieldset-${fieldSet}`);
				});
			}
		},
		checkIsWorkOrderProcessDetailDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		goToNext(page, item) {
			
			this.scanPageIndex = page;
			if(page < 1) this.scanPageIndex = 1;
			if(page > 4) this.scanPageIndex = 4;

			if(page == 1) {
				this.modalTitle = 'Receipt From Production Input';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-work-order-process-detail");
				});
			}

			if(page == 2 && item) {
				this.modelId = item;

				this.modalTitle = 'Receipt From Production Ng & Pending Input';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-receipt-material");
				});
				
			}

			if(page == 3) {
				this.modalTitle = 'Receipt From Production Case Input';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-receipt-from-production-case");
				});
			}

			if(page == 4) {
				this.modalTitle = 'Receipt From Production Material Input';
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-receipt-material-ok");
				});
			}

			// if(page == 2) {
			// 	this.model.workOrderProcessDetail = item;
			// 	this.model.workOrderProcessDetailId = item.id;
			// 	this.parentLabelInfo = 'Work Order';
			// 	this.parentValueInfo = item.part;
			// 	this.updateData().then((result) => {
			// 		let data = {};
			// 		let qrCode = encodeURIComponent(item.part);
			// 		let this_ = this;
			// 		this.$http.post('ReceiptFromProduction/PopulateDetail/' + this.model.id + '/' + qrCode , data
			// 		).then(async function(response){
			// 			this_.scanPageIndex = page;
			// 		})
			// 		.catch(error => {
			// 			this_.$store.dispatch('addErrorMessageGlobal', error);
			// 			return;
			// 		});
			// 		this.scanPageIndex = page;
			// 	});
			// 	return;
			// }

			// if(page == 3) {
			// 	this.saveAction();
			// 	return;
			// }

		},
	},
	beforeMount() {
		this.filterReceiptFromProduction = new ReceiptFromProductionFilter();
		this.filterReceiptFromProductionMaterial = new ReceiptFromProductionMaterialFilter();
		this.filterReceiptFromProductionCase = new ReceiptFromProductionCaseFilter();
		//this.getReceiptFromProductions();
		//this.getControlCards();
		//this.getParts();
		//this.getWorkOrderProcessDetails();
		//this.getDocumentStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			await this.getReceiptFromProduction(id);
			if(!this.workOrderProcessDetail) {
				await this.getWorkOrderProcessDetail(this.model.workOrderProcessDetailId);
			}

			this.$nextTick(() => {
				this.focusInput(this, "fieldset-work-order-process-detail");
			});
		}
		this.$nextTick(() => {
			this.isBusy = true;
			this.getWorkOrderProcessDetails();
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
			this.$nextTick(() => {
				if(this.model.workOrderProcessDetail && this.model.workOrderProcessDetail.lotNo) {
					this.scanWorkOrderProcessDetail(this.model.workOrderProcessDetail.lotNo);
				} else {
					this.isBusy = false;
				}
			})
		});
	},
	computed: {
		deliveryDate() {
			if(this.receiptFromProductionCases.length == 0) return null;
			const validDeliveryDates = this.receiptFromProductionCases
				.map(caseItem => caseItem.controlCard.deliveryDate)
				.filter(date => date !== null && date !== undefined);
			
			// Return the first valid delivery date, or null if none are found
			return validDeliveryDates.length > 0 ? validDeliveryDates[0] : null;
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
	watch : {
	},
}
</script>
